import React, { useEffect, useState, ReactNode, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, round } from 'lodash';

import './scss/change-rate.scss';
import SubTitle from '../component/sub-title';
import Color from '@/tool/color';

import Tab from '../component/tab';
import TimeTab from '../component/time-tab';
import moChangeRate, { changeTab, changeTimeTab } from './store/change-rate';
import Empty from '@/component/empty';
import { newRateABS } from '@tool/index';
import moEffectPdf from '../store';
import MainTitle from '../component/main-title';
import URI from 'urijs';
import Sub from '../component/sub';
import moMenu from '@/page/effect/store/menu';


interface IProps { }
interface IState { }

const ChangeRate = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const uri = new URI(window.location.href);
  const path: any = uri.query(true);
  const result: any = decodeURIComponent(path.check);
  const data = JSON.parse(result);
  const { rateList } = moChangeRate;

  const emen: any = {
    人均营业收入: 'revenue_per_staff',
    人均净利润: 'profit_per_staff',
    人均薪酬成本: 'cost_per_staff',
  };

  const getData = (val: string) => {
    const active = emen[val];
    let list: any = {};
    let child: any = [];
    let allCompany = 1;
    if (!isEmpty(rateList)) {
      list = rateList[active];
      rateList[active].distribution.forEach((ele: any) => {
        if (ele.count > allCompany) {
          allCompany = ele.count;
        }
      });
      child = rateList[active].distribution.map((res: any, r: any) => {
        const item: any = {};
        if (r < 4) {
          item.type = 'down';
        }
        if (r === 4) {
          item.type = 'stable';
        }
        if (r > 4) {
          item.type = 'up';
        }
        item.value = res.count;
        item.label = res.label;
        return item;
      });
    }
    return { list, child, allCompany };
  };

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section id="effect03" className="change-rate-warp-pdf human-common-pdf">
      <MainTitle
        title='变化率分布'
        subtitle={moMenu.industryName}
        year={data.tabList.ct}
        bgcolor={Color.primaryColor(0.1)}
        color={Color.primary} />
      {data.tabList?.c1 && <section>
        <Sub title='人均营业收入' />
        {!isEmpty(getData('人均营业收入')?.child) && getData('人均营业收入').child.filter((res: any) => res.value !== 0).length > 0 ? (<section className="rate-chart">
          <section className="content-05010 content-05011">
            <section className="content-05015 content-05017">
              <section className="box-001">
                <b className='left-001'>
                  {round(getData('人均营业收入')?.list?.decline_rate * 100, 0)}%
                </b>
                <b className='right-001'>
                  {round(getData('人均营业收入')?.list?.increase_rate * 100, 0)}%
                </b>
                <p className="line-001">
                  <b>{getData('人均营业收入')?.list?.decline_count}家企业人均营业收入下降</b>
                  <b>{getData('人均营业收入')?.list?.increase_count}家企业人均营业收入增长</b>
                </p>
                <p className="line-002">
                  <b style={{
                    width: `${getData('人均营业收入')?.list?.decline_count * 100 / getData('人均营业收入').allCompany}%`,
                  }} />
                  <span style={{
                    width: `${getData('人均营业收入')?.child[4].value * 100 / getData('人均营业收入').allCompany}%`,
                  }}>
                    <i />
                  </span>
                  <strong style={{
                    width: `${getData('人均营业收入')?.list?.increase_count * 100 / getData('人均营业收入').allCompany}%`,
                  }} />
                </p>
              </section>
              <section className="box-002">
                <section className="section-01 section-03">
                  {getData('人均营业收入')?.child?.map((item: any, index: number) => (
                    <p key={index}
                      className={[
                        'item-002',
                        item.type === 'up' ? 'up-002' : '',
                        item.type === 'down' ? 'down-002' : '',
                        item.type === 'stable' ? 'stable-002' : '',
                      ].join(' ')}>
                      <b>{item.value}家</b>
                      <strong style={{
                        height: `${item.value * 100 / getData('人均营业收入').allCompany}%`,
                      }} />
                    </p>
                  ))}
                </section>
                <p className="section-01 section-02">
                  {getData('人均营业收入')?.child?.map((item: any, index: number) => (
                    <span key={index}>{item.label}</span>
                  ))}
                </p>
              </section>
            </section>
          </section>
        </section>) : (
          <Empty />
        )}
      </section>}

      {data.tabList?.c2 && <section>
        <Sub title='人均净利润' />
        {!isEmpty(getData('人均净利润')?.child) && getData('人均净利润').child.filter((res: any) => res.value !== 0).length > 0 ? (<section className="rate-chart">
          <section className="content-05010 content-05011">
            <section className="content-05015 content-05017">
              <section className="box-001">
                <b className='left-001'>
                  {round(getData('人均净利润')?.list?.decline_rate * 100, 0)}%
                </b>
                <b className='right-001'>
                  {round(getData('人均净利润')?.list?.increase_rate * 100, 0)}%
                </b>
                <p className="line-001">
                  <b>{getData('人均净利润')?.list?.decline_count}家企业人均净利润下降</b>
                  <b>{getData('人均净利润')?.list?.increase_count}家企业人均净利润增长</b>
                </p>
                <p className="line-002">
                  <b style={{
                    width: `${getData('人均净利润')?.list?.decline_count * 100 / getData('人均净利润').allCompany}%`,
                  }} />
                  <span style={{
                    width: `${getData('人均净利润')?.child[4].value * 100 / getData('人均净利润').allCompany}%`,
                  }}>
                    <i />
                  </span>
                  <strong style={{
                    width: `${getData('人均净利润')?.list?.increase_count * 100 / getData('人均净利润').allCompany}%`,
                  }} />
                </p>
              </section>
              <section className="box-002">
                <section className="section-01 section-03">
                  {getData('人均净利润')?.child?.map((item: any, index: number) => (
                    <p key={index}
                      className={[
                        'item-002',
                        item.type === 'up' ? 'up-002' : '',
                        item.type === 'down' ? 'down-002' : '',
                        item.type === 'stable' ? 'stable-002' : '',
                      ].join(' ')}>
                      <b>{item.value}家</b>
                      <strong style={{
                        height: `${item.value * 100 / getData('人均净利润').allCompany}%`,
                      }} />
                    </p>
                  ))}
                </section>
                <p className="section-01 section-02">
                  {getData('人均净利润')?.child?.map((item: any, index: number) => (
                    <span key={index}>{item.label}</span>
                  ))}
                </p>
              </section>
            </section>
          </section>
        </section>) : (
          <Empty />
        )}
      </section>}

      {data.tabList?.c3 && <section>
        <Sub title='人均薪酬成本' />
        {!isEmpty(getData('人均薪酬成本')?.child) && getData('人均薪酬成本').child.filter((res: any) => res.value !== 0).length > 0 ? (<section className="rate-chart">
          <section className="content-05010 content-05011">
            <section className="content-05015 content-05017">
              <section className="box-001">
                <b className='left-001'>
                  {round(getData('人均薪酬成本')?.list?.decline_rate * 100, 0)}%
                </b>
                <b className='right-001'>
                  {round(getData('人均薪酬成本')?.list?.increase_rate * 100, 0)}%
                </b>
                <p className="line-001">
                  <b>{getData('人均薪酬成本')?.list?.decline_count}家企业人均薪酬成本下降</b>
                  <b>{getData('人均薪酬成本')?.list?.increase_count}家企业人均薪酬成本增长</b>
                </p>
                <p className="line-002">
                  <b style={{
                    width: `${getData('人均薪酬成本')?.list?.decline_count * 100 / getData('人均薪酬成本').allCompany}%`,
                  }} />
                  <span style={{
                    width: `${getData('人均薪酬成本')?.child[4].value * 100 / getData('人均薪酬成本').allCompany}%`,
                  }}>
                    <i />
                  </span>
                  <strong style={{
                    width: `${getData('人均薪酬成本')?.list?.increase_count * 100 / getData('人均薪酬成本').allCompany}%`,
                  }} />
                </p>
              </section>
              <section className="box-002">
                <section className="section-01 section-03">
                  {getData('人均薪酬成本')?.child?.map((item: any, index: number) => (
                    <p key={index}
                      className={[
                        'item-002',
                        item.type === 'up' ? 'up-002' : '',
                        item.type === 'down' ? 'down-002' : '',
                        item.type === 'stable' ? 'stable-002' : '',
                      ].join(' ')}>
                      <b>{item.value}家</b>
                      <strong style={{
                        height: `${item.value * 100 / getData('人均薪酬成本').allCompany}%`,
                      }} />
                    </p>
                  ))}
                </section>
                <p className="section-01 section-02">
                  {getData('人均薪酬成本')?.child?.map((item: any, index: number) => (
                    <span key={index}>{item.label}</span>
                  ))}
                </p>
              </section>
            </section>
          </section>
        </section>) : (
          <Empty />
        )}
      </section>}
    </section>
  );
};

export default observer(ChangeRate);
